export default __webpack_public_path__ + "static/media/visa.b5d6f908.jpg";